import { CommandGetCatalogSettings } from "./commands/cmdGetCatalogSettings";
import { CmdSaveCollectionHero } from "./commands/cmdSaveCollectionHero";
import { CmdSaveStoreHero } from "./commands/cmdSaveStoreHero";
import { CmdSaveTagHero } from "./commands/cmdSaveTagHero";
import { CommandSaveCatalogSettings } from "./commands/CommandSaveCatalogSettings";

export class ContentCatalogSettingsService {
  async getStoreSettings(organizationId: number) {
    const cmd = new CommandGetCatalogSettings();
    const results = await cmd.run(organizationId);
    return results;
  }

  async saveStoreSettings(storeSettings: any, organizationId: number, pageName: string) {
    const cmd = new CommandSaveCatalogSettings();
    const results = await cmd.run(storeSettings, organizationId, pageName);
    return results;
  }

  async uploadStoreHero(hero: File, organizationId: number) {
    const cmd = new CmdSaveStoreHero();
    const results = await cmd.run(hero, organizationId);
    return results;
  }

  async uploadCollectionHero(
    hero: File,
    organizationId: number,
    collectionId: number
  ) {
    const cmd = new CmdSaveCollectionHero();
    const results = await cmd.run(hero, organizationId, collectionId);
    return results;
  }

  async uploadTagHero(hero: File, organizationId: number, tagId: number) {
    const cmd = new CmdSaveTagHero();
    const results = await cmd.run(hero, organizationId, tagId);
    return results;
  }
}
